module.exports = __webpack_public_path__ + "img/device_c6s_one.c18fc51c.jpg";